import React, { useContext, useState } from "react";
import { popupcontext } from "../../../../context/Popupscontext";
import { useGetSpecificVehicleImeiQuery } from "../../../../Redux/service/Vehicles/Vehicles";
import SelectedDeviceInf from "../../../LiveTracking/ObjectSelected/SelectedBody/SelectedDevices/SelectedDeviceInf";
import SelectedDeviceAssign from "../../../LiveTracking/ObjectSelected/SelectedBody/SelectedDevices/SelectedDeviceAssign";
import TrackedSelectedHead from "./TrackedSelectedHead";
import TrackedSelectedMap from "./TrackedSelectedMap";
import TrackedSelectedTabs from "./TrackedSelectedTabs";
import { Segmented } from "antd";
import trans from "../../../../utils";
import Button from "../../../Helpers/Button/Button";
import { livetrackingcontext } from "../../../../context/LiveTrackingContext";

export default function TrackedSelectedVehicle({
	imei,
	device,
	position,
	setimei,
	type,
	values,
}) {
	let { objectselect } = useContext(popupcontext);
	let { data: Vehicles } = useGetSpecificVehicleImeiQuery(imei);
	const lang = localStorage.getItem("lang") || "en";
	console.log("values", values);
	const [showmore, setShowmore] = useState(false);
	const [trackingType, setTrackingType] = useState("info");
	let { trackingType: vtype } = useContext(livetrackingcontext);

	return (
		<>
			{objectselect === true && (
				<div
					className={`bg-white-rounded p-0 tracked-vehicle-selected ${
						lang === "en"
							? "tracked-vehicle-selected-ltr"
							: "tracked-vehicle-selected-rtl"
					}`}
				>
					<div className="streetview">
						<TrackedSelectedHead
							values={values}
							device={device}
							setimei={setimei}
						/>
						<div className="H-line"></div>
						{/* {vtype === "vehicle" && (
							<div style={{ padding: "8px" }}>
								<Segmented
									options={[
										{ label: trans("Vehicle Info"), value: "info" },
										{ label: trans("Streaming"), value: "streaming" },
									]}
									style={{
										textTransform: "capitalize",
										border: "1px solid #CFCFCF",
									}}
									onChange={(value) => {
										setTrackingType(value);
									}}
									value={trackingType}
									size="middle"
									block
								/>
							</div>
						)} */}
					</div>

					<TrackedSelectedMap position={position} />

					{type === "vehicle" && (
						<>
							{trackingType === "info" && (
								<>
									<TrackedSelectedTabs
										title="Vehicle Details"
										img="Cardetails"
										values={Vehicles}
										device={device ? device : values}
										show={false}
										setShowmore={setShowmore}
										showmore={showmore}
									/>
									{showmore && (
										<>
											<TrackedSelectedTabs
												title="working status"
												img="CarBattery"
												values={Vehicles}
												device={device}
												position={position}
											/>
											<TrackedSelectedTabs
												title="sensors"
												img="Sensors"
												position={position}
												CarSensors={Vehicles}
											/>
											<TrackedSelectedTabs
												title="controls"
												img="Control"
												device={device}
												values={values}
											/>
											{showmore && (
												<div style={{ padding: "12px" }}>
													<Button
														className="default"
														text={trans("Less Actions")}
														style={{
															display: "flex",
															margin: "auto",
															width: "100%",
														}}
														onClick={() => setShowmore(false)}
													/>
												</div>
											)}
										</>
									)}
								</>
							)}
							{trackingType === "streaming" && (
								<TrackedSelectedTabs
									title="camera"
									img="Camera"
									device={device}
								/>
							)}
						</>
					)}
					{type === "mobility" && (
						<>
							<SelectedDeviceInf
								values={Vehicles}
								device={device}
								show={false}
							/>
							<SelectedDeviceAssign
								values={Vehicles}
								device={device}
								show={false}
							/>
						</>
					)}
				</div>
			)}
		</>
	);
}
